<div class="pt-3" *ngIf="eventTypeNotFound">
  <h2>Event not found</h2>
</div>

<div class="pt-3" *ngIf="eventQuestionsNotFound">
  <h2>Questions not found</h2>
</div>

<div class="pt-3" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6" *ngIf="!eventTypeNotFound && (serverError === null)">
  <div class="row">
    <div class="col">
      <p class="mt-2" style="width:100%;text-align:center">
        <span *ngIf="eventType === null">LOADING EVENT...</span>
        <span *ngIf="eventType !== null">EDIT EVENT: {{ eventType.name }}</span>
      </p>
    </div>
  </div>

  <div class="mb-5 border-rounded-10">

    <app-event-setup-nav [loadingEventType]="loadingEventType" [eventType]="eventType"></app-event-setup-nav>

    <div class="m-4">

      <h3>Participant Questions</h3>

      <div class="alert alert-info">
        Participant questions are filled out for each participant on the booking. For example, if a parent is registering two children onto Summer Camp, they will answer each participant question twice, once for each child.
        <br>
        In order to configure questions which are answered once for the entire booking, scroll down to "Booking Customer Questions" below.
      </div>

      <div class="row">
        <div class="col-md-8 col-xl-6">
          <div class="form-group">
            <label>First Name *</label>
            <input type="text" class="form-control">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-8 col-xl-6">
          <div class="form-group">
            <label>Last Name *</label>
            <input type="text" class="form-control">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-8 col-xl-6">
          <div class="form-group">
            <label>Birthday *</label>
            <input type="date" class="form-control">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-8 col-xl-6">
          <div class="form-group">
            <label>Email</label>
            <input type="email" class="form-control">
          </div>
        </div>
      </div>

      <div class="row" *ngFor="let question of participantQuestions; let questionIndex = index">

        <div class="col-md-8 col-xl-6 ml-3 mb-3 indented-subsection" *ngIf="questionInEditMode[question.id]">

          <div class="form-group">
            <label>Question Type</label>
            <select class="custom-select"
                    [(ngModel)]="question.question_type">
              <option value="{{ EventQuestionType.preferredName }}" [disabled]="isPreferredNameSelected(EventQuestionScope.participant)">Preferred Name</option>
              <option value="{{ EventQuestionType.singleLineText }}">Single-line Text</option>
              <option value="{{ EventQuestionType.multipleLineText }}">Multiple-line Text</option>
              <option value="{{ EventQuestionType.multipleChoice }}">Multiple Choice</option>
              <option value="{{ EventQuestionType.singleCheckbox }}">Single Checkbox</option>
              <option value="{{ EventQuestionType.multipleCheckboxes }}">Multiple Checkboxes</option>
              <option value="{{ EventQuestionType.customCustomerField }}">Custom Customer Field</option>
            </select>
            <div class="form-text text-danger" *ngIf="eventQuestionsErrors[question.id]">
              {{ eventQuestionsErrors[question.id].question_type }}
            </div>
          </div>

          <div class="form-group" *ngIf="question.question_type !== EventQuestionType.customCustomerField">
            <label>Question Name</label>
            <app-markdown-editor-single-line [id]="'questionName' + questionIndex.toString()"
                                             [(content)]="question.name"></app-markdown-editor-single-line>
            <div class="form-text text-danger" *ngIf="eventQuestionsErrors[question.id]">
              {{ eventQuestionsErrors[question.id].name }}
            </div>
          </div>

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.customCustomerField">
            <label>Custom Customer Field</label>
            <ng-container *ngIf="!loadingCustomCustomerFields">
              <ng-container *appVar="getUnusedCustomCustomerFields(question) as unusedCustomFields">
                <select class="custom-select"
                        *ngIf="unusedCustomFields.length > 0"
                        [(ngModel)]="question.custom_customer_field_id">
                  <option *ngFor="let field of unusedCustomFields" [value]="field.id">{{ field.name }}</option>
                </select>
                <select class="custom-select disabled" disabled
                        *ngIf="unusedCustomFields.length === 0">
                  <option *ngIf="customCustomerFields.length === 0">No fields configured</option>
                  <option *ngIf="customCustomerFields.length > 0">All fields already added</option>
                </select>
              </ng-container>
            </ng-container>
            <select class="custom-select disabled" disabled
                    *ngIf="loadingCustomCustomerFields">
              <option>Loading...</option>
            </select>
            <div class="form-text text-danger" *ngIf="eventQuestionsErrors[question.id]">
              {{ eventQuestionsErrors[question.id].custom_customer_field_id }}
            </div>
          </div>

          <div class="form-group">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" [(ngModel)]="question.is_required" id="required{{ question.id }}">
              <label class="form-check-label" for="required{{ question.id }}">Required?</label>
            </div>
            <small class="form-text text-muted" *ngIf="question.question_type === EventQuestionType.multipleCheckboxes">
              If "Required" is selected, at least one checkbox must be selected in order to make the booking
            </small>
            <div class="form-text text-danger" *ngIf="eventQuestionsErrors[question.id]">
              {{ eventQuestionsErrors[question.id].is_required }}
            </div>
          </div>

          <div class="form-group" *ngIf="question.is_required && (question.question_type === EventQuestionType.multipleCheckboxes)">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" [(ngModel)]="question.all_options_required" id="all_options_required{{ question.id }}">
              <label class="form-check-label" for="all_options_required{{ question.id }}">All Checkboxes Required?</label>
            </div>
            <small class="form-text text-muted" *ngIf="question.question_type === EventQuestionType.multipleCheckboxes">
              If "All Checkboxes Required" is selected, all checkboxes must be selected in order to make the booking.
            </small>
            <div class="form-text text-danger" *ngIf="eventQuestionsErrors[question.id]">
              {{ eventQuestionsErrors[question.id].all_options_required }}
            </div>
          </div>

          <div class="form-group">
            <label>Help Text</label>
            <app-markdown-editor [id]="'questionDescription' + questionIndex.toString()"
                                 [(content)]="question.description"
                                 [shortEditor]="true"></app-markdown-editor>
            <div class="form-text text-danger" *ngIf="eventQuestionsErrors[question.id]">
              {{ eventQuestionsErrors[question.id].description }}
            </div>
          </div>

          <div class="form-group" *ngIf="questionHasOptions(question)">
            <label>Options</label>
            <textarea type="text" class="form-control"
                      [(ngModel)]="question.options"></textarea>
            <small class="form-text text-muted">
              Provide a list of options, separated by commas.
            </small>
            <div class="form-text text-danger" *ngIf="eventQuestionsErrors[question.id]">
              {{ eventQuestionsErrors[question.id].description }}
            </div>
          </div>

          <div class="alert alert-danger" role="alert"
               *ngIf="eventQuestionsErrors[question.id] && eventQuestionsErrors[question.id].non_field_errors">
            {{ eventQuestionsErrors[question.id].non_field_errors }}
          </div>
          <div class="alert alert-danger" role="alert"
               *ngIf="eventQuestionsErrorMessage[question.id]">
            {{ eventQuestionsErrorMessage[question.id] }}
          </div>

          <div class="alert alert-info" role="alert"
               *ngIf="loadingEventQuestions[question.id]">
            Saving...
          </div>

          <div class="row">
            <div class="col">
              <button class="btn btn-secondary btn-sm mb-2 mr-2"
                      [disabled]="questionIndex === 0"
                      [class.disabled]="questionIndex === 0"
                      (click)="shiftQuestion(question, true)">
                &uarr; Move Question Up
              </button>
              <button class="btn btn-secondary btn-sm mb-2"
                      [disabled]="questionIndex >= (participantQuestions.length - 1)"
                      [class.disabled]="questionIndex >= (participantQuestions.length - 1)"
                      (click)="shiftQuestion(question, false)">
                &darr; Move Question Down
              </button>
            </div>
          </div>

          <button class="btn btn-primary" (click)="saveQuestion(question)">
            Save Question
          </button>

          <button class="btn btn-danger float-right" (click)="removeQuestion(question)">
            Remove Question
          </button>

        </div>

        <div class="col-md-8 col-xl-6" *ngIf="!questionInEditMode[question.id]">

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.preferredName">
            <label>
              <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
              <span *ngIf="question.is_required">&nbsp;*</span>
            </label>
            <button class="btn btn-link btn-sm pt-0 float-right"
                    (click)="questionInEditMode[question.id] = true">
              Edit Question
            </button>
            <input type="text" class="form-control">
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedMarkdown(question.description)"></small>
          </div>

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.singleLineText">
            <label>
              <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
              <span *ngIf="question.is_required">&nbsp;*</span>
            </label>
            <button class="btn btn-link btn-sm pt-0 float-right"
                    (click)="questionInEditMode[question.id] = true">
              Edit Question
            </button>
            <input type="text" class="form-control">
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedMarkdown(question.description)"></small>
          </div>

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.multipleLineText">
            <label>
              <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
              <span *ngIf="question.is_required">&nbsp;*</span>
            </label>
            <button class="btn btn-link btn-sm pt-0 float-right"
                    (click)="questionInEditMode[question.id] = true">
              Edit Question
            </button>
            <textarea class="form-control"></textarea>
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedMarkdown(question.description)"></small>
          </div>

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.multipleChoice">
            <div class="d-inline-block w-100">
              <label class="mb-1">
                <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
                <span *ngIf="question.is_required">&nbsp;*</span>
              </label>
              <button class="btn btn-link btn-sm pt-0 float-right"
                      (click)="questionInEditMode[question.id] = true">
                Edit Question
              </button>
            </div>
            <div class="form-check" *ngFor="let option of question.options.split(',')">
              <input class="form-check-input" type="radio" name="{{ question.id }}">
              <label class="form-check-label">{{ option }}</label>
            </div>
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedMarkdown(question.description)"></small>
          </div>

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.singleCheckbox">
            <div class="form-check">
              <input type="checkbox" class="form-check-input">
              <label class="form-check-label">
                <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
                <span *ngIf="question.is_required">&nbsp;*</span>
              </label>
              <button class="btn btn-link btn-sm pt-0 float-right"
                      (click)="questionInEditMode[question.id] = true">
                Edit Question
              </button>
            </div>
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedMarkdown(question.description)"></small>
          </div>

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.multipleCheckboxes">
            <div class="d-inline-block w-100">
              <label class="mb-1">
                <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
                <span *ngIf="question.is_required">&nbsp;*</span>
              </label>
              <button class="btn btn-link btn-sm pt-0 float-right"
                      (click)="questionInEditMode[question.id] = true">
                Edit Question
              </button>
            </div>
            <div class="form-check" *ngFor="let option of question.options.split(',')">
              <input class="form-check-input" type="checkbox" name="{{ question.id }}">
              <label class="form-check-label">{{ option }}</label>
            </div>
            <small class="form-text text-muted"
                   *ngIf="question.is_required">
              <ng-container *ngIf="question.all_options_required">
                All of the above checkboxes must be selected before proceeding.
              </ng-container>
              <ng-container *ngIf="!question.all_options_required">
                At least one of the above checkboxes must be selected before proceeding.
              </ng-container>
            </small>
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedMarkdown(question.description)"></small>
          </div>

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.customCustomerField">

            <ng-container *ngIf="question.custom_customer_field_type === CustomCustomerFieldType.checkboxes">
              <div class="d-inline-block w-100">
                <label class="mb-1">
                  {{ question.custom_customer_field_name }}
                  <span *ngIf="question.is_required">*</span>
                </label>
                <button class="btn btn-link btn-sm pt-0 float-right"
                        (click)="questionInEditMode[question.id] = true">
                  Edit Question
                </button>
              </div>
              <div class="form-check" *ngFor="let option of question.custom_customer_field_options; index as idx">
                <input class="form-check-input" type="checkbox"
                       name="customFieldCHK{{ question.custom_customer_field_id }}-{{ idx }}"
                       id="customFieldCHK{{ question.custom_customer_field_id }}-{{ idx }}">
                <label class="form-check-label" for="customFieldCHK{{ question.custom_customer_field_id }}-{{ idx }}">
                  {{ option }}
                </label>
              </div>
            </ng-container>

            <ng-container *ngIf="question.custom_customer_field_type === CustomCustomerFieldType.dropdown">
              <label class="mb-1"
                     for="customFieldDRP{{ question.custom_customer_field_id }}">
                {{ question.custom_customer_field_name }}
                <span *ngIf="question.is_required">*</span>
              </label>
              <button class="btn btn-link btn-sm pt-0 float-right"
                      (click)="questionInEditMode[question.id] = true">
                Edit Question
              </button>
              <select class="custom-select"
                      id="customFieldDRP{{ question.custom_customer_field_id }}"
                      name="customFieldDRP{{ question.custom_customer_field_id }}">
                <option *ngFor="let option of question.custom_customer_field_options">
                  {{ option }}
                </option>
              </select>
            </ng-container>

            <ng-container *ngIf="question.custom_customer_field_type === CustomCustomerFieldType.radio">
              <div class="d-inline-block w-100">
                <label class="mb-1">
                  {{ question.custom_customer_field_name }}
                  <span *ngIf="question.is_required">*</span>
                </label>
                <button class="btn btn-link btn-sm pt-0 float-right"
                        (click)="questionInEditMode[question.id] = true">
                  Edit Question
                </button>
              </div>
              <div class="form-check" *ngFor="let option of question.custom_customer_field_options; index as idx">
                <input class="form-check-input" type="radio"
                       id="customFieldRDO{{ question.custom_customer_field_id }}-{{ idx }}"
                       name="customFieldRDO{{ question.custom_customer_field_id }}">
                <label class="form-check-label" for="customFieldRDO{{ question.custom_customer_field_id }}-{{ idx }}">
                  {{ option }}
                </label>
              </div>
            </ng-container>

            <ng-container *ngIf="question.custom_customer_field_type === CustomCustomerFieldType.singleLineText">
              <label class="mb-1"
                     for="customFieldSLT{{ question.custom_customer_field_id }}">
                {{ question.custom_customer_field_name }}
                <span *ngIf="question.is_required">*</span>
              </label>
              <button class="btn btn-link btn-sm pt-0 float-right"
                      (click)="questionInEditMode[question.id] = true">
                Edit Question
              </button>
              <input id="customFieldSLT{{ question.custom_customer_field_id }}"
                     name="customFieldSLT{{ question.custom_customer_field_id }}"
                     type="text" class="form-control" maxlength="127">
            </ng-container>

            <ng-container *ngIf="question.custom_customer_field_type === CustomCustomerFieldType.multipleLineText">
              <label class="mb-1"
                     for="customFieldMLT{{ question.custom_customer_field_id }}">
                {{ question.custom_customer_field_name }}
                <span *ngIf="question.is_required">*</span>
              </label>
              <button class="btn btn-link btn-sm pt-0 float-right"
                      (click)="questionInEditMode[question.id] = true">
                Edit Question
              </button>
              <textarea id="customFieldMLT{{ question.custom_customer_field_id }}"
                        name="customFieldMLT{{ question.custom_customer_field_id }}"
                        class="form-control"></textarea>
            </ng-container>

            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedMarkdown(question.description)"></small>

          </div>

        </div>

      </div>

      <div class="row">
        <div class="col">
          <button class="btn btn-outline-primary mb-4"
                  (click)="addNewQuestion(EventQuestionScope.participant)">
            Add Participant Question
          </button>
        </div>
      </div>

      <div class="alert alert-info" role="alert" *ngIf="loadingEventQuestionsList">
        Loading questions...
      </div>

      <h3>Booking Customer Questions</h3>

      <div class="alert alert-info">
        Booking customer specific questions are questions only asked once for the entire booking. For customer information questions (such as Preferred Name), the response will be associated with the customer making the booking.
      </div>

      <div class="row" *ngFor="let question of bookingCustomerQuestions; let questionIndex = index">

        <div class="col-md-8 col-xl-6 ml-3 mb-3 indented-subsection" *ngIf="questionInEditMode[question.id]">

          <div class="form-group">
            <label>Question Type</label>
            <select class="custom-select"
                    [(ngModel)]="question.question_type">
              <option value="{{ EventQuestionType.preferredName }}" [disabled]="isPreferredNameSelected(EventQuestionScope.bookingCustomer)">Preferred Name</option>
              <option value="{{ EventQuestionType.singleLineText }}">Single-line Text</option>
              <option value="{{ EventQuestionType.multipleLineText }}">Multiple-line Text</option>
              <option value="{{ EventQuestionType.multipleChoice }}">Multiple Choice</option>
              <option value="{{ EventQuestionType.singleCheckbox }}">Single Checkbox</option>
              <option value="{{ EventQuestionType.multipleCheckboxes }}">Multiple Checkboxes</option>
              <option value="{{ EventQuestionType.customCustomerField }}">Custom Customer Field</option>
            </select>
            <div class="form-text text-danger" *ngIf="eventQuestionsErrors[question.id]">
              {{ eventQuestionsErrors[question.id].question_type }}
            </div>
          </div>

          <div class="form-group" *ngIf="question.question_type !== EventQuestionType.customCustomerField">
            <label>Question Name</label>
            <app-markdown-editor-single-line [id]="'questionName' + questionIndex.toString()"
                                             [(content)]="question.name"></app-markdown-editor-single-line>
            <div class="form-text text-danger" *ngIf="eventQuestionsErrors[question.id]">
              {{ eventQuestionsErrors[question.id].name }}
            </div>
          </div>

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.customCustomerField">
            <label>Custom Customer Field</label>
            <ng-container *ngIf="!loadingCustomCustomerFields">
              <ng-container *appVar="getUnusedCustomCustomerFields(question) as unusedCustomFields">
                <select class="custom-select"
                        *ngIf="unusedCustomFields.length > 0"
                        [(ngModel)]="question.custom_customer_field_id">
                  <option *ngFor="let field of unusedCustomFields" [value]="field.id">{{ field.name }}</option>
                </select>
                <select class="custom-select disabled" disabled
                        *ngIf="unusedCustomFields.length === 0">
                  <option *ngIf="customCustomerFields.length === 0">No fields configured</option>
                  <option *ngIf="customCustomerFields.length > 0">All fields already added</option>
                </select>
              </ng-container>
            </ng-container>
            <select class="custom-select disabled" disabled
                    *ngIf="loadingCustomCustomerFields">
              <option>Loading...</option>
            </select>
            <div class="form-text text-danger" *ngIf="eventQuestionsErrors[question.id]">
              {{ eventQuestionsErrors[question.id].custom_customer_field_id }}
            </div>
          </div>

          <div class="form-group">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" [(ngModel)]="question.is_required" id="required{{ question.id }}">
              <label class="form-check-label" for="required{{ question.id }}">Required?</label>
            </div>
            <small class="form-text text-muted" *ngIf="question.question_type === EventQuestionType.multipleCheckboxes">
              If "Required" is selected, at least one checkbox must be selected in order to make the booking.
            </small>
            <div class="form-text text-danger" *ngIf="eventQuestionsErrors[question.id]">
              {{ eventQuestionsErrors[question.id].is_required }}
            </div>
          </div>

          <div class="form-group" *ngIf="question.is_required && (question.question_type === EventQuestionType.multipleCheckboxes)">
            <div class="form-check">
              <input type="checkbox" class="form-check-input" [(ngModel)]="question.all_options_required" id="all_options_required{{ question.id }}">
              <label class="form-check-label" for="all_options_required{{ question.id }}">All Checkboxes Required?</label>
            </div>
            <small class="form-text text-muted" *ngIf="question.question_type === EventQuestionType.multipleCheckboxes">
              If "All Checkboxes Required" is selected, all checkboxes must be selected in order to make the booking.
            </small>
            <div class="form-text text-danger" *ngIf="eventQuestionsErrors[question.id]">
              {{ eventQuestionsErrors[question.id].all_options_required }}
            </div>
          </div>

          <div class="form-group">
            <label>Help Text</label>
            <app-markdown-editor [id]="'questionDescription' + questionIndex.toString()"
                                 [(content)]="question.description"
                                 [shortEditor]="true"></app-markdown-editor>
            <div class="form-text text-danger" *ngIf="eventQuestionsErrors[question.id]">
              {{ eventQuestionsErrors[question.id].description }}
            </div>
          </div>

          <div class="form-group" *ngIf="questionHasOptions(question)">
            <label>Options</label>
            <textarea type="text" class="form-control"
                      [(ngModel)]="question.options"></textarea>
            <small class="form-text text-muted">
              Provide a list of options, separated by commas.
            </small>
            <div class="form-text text-danger" *ngIf="eventQuestionsErrors[question.id]">
              {{ eventQuestionsErrors[question.id].description }}
            </div>
          </div>

          <div class="alert alert-danger" role="alert"
               *ngIf="eventQuestionsErrors[question.id] && eventQuestionsErrors[question.id].non_field_errors">
            {{ eventQuestionsErrors[question.id].non_field_errors }}
          </div>
          <div class="alert alert-danger" role="alert"
               *ngIf="eventQuestionsErrorMessage[question.id]">
            {{ eventQuestionsErrorMessage[question.id] }}
          </div>

          <div class="alert alert-info" role="alert"
               *ngIf="loadingEventQuestions[question.id]">
            Saving...
          </div>

          <div class="row">
            <div class="col">
              <button class="btn btn-secondary btn-sm mb-2 mr-2"
                      [disabled]="questionIndex === 0"
                      [class.disabled]="questionIndex === 0"
                      (click)="shiftQuestion(question, true)">
                &uarr; Move Question Up
              </button>
              <button class="btn btn-secondary btn-sm mb-2"
                      [disabled]="questionIndex >= (bookingCustomerQuestions.length - 1)"
                      [class.disabled]="questionIndex >= (bookingCustomerQuestions.length - 1)"
                      (click)="shiftQuestion(question, false)">
                &darr; Move Question Down
              </button>
            </div>
          </div>

          <button class="btn btn-primary" (click)="saveQuestion(question)">
            Save Question
          </button>

          <button class="btn btn-danger float-right" (click)="removeQuestion(question)">
            Remove Question
          </button>

        </div>

        <div class="col-md-8 col-xl-6" *ngIf="!questionInEditMode[question.id]">

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.preferredName">
            <label>
              <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
              <span *ngIf="question.is_required">&nbsp;*</span>
            </label>
            <button class="btn btn-link btn-sm pt-0 float-right"
                    (click)="questionInEditMode[question.id] = true">
              Edit Question
            </button>
            <input type="text" class="form-control">
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedMarkdown(question.description)"></small>
          </div>

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.singleLineText">
            <label>
              <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
              <span *ngIf="question.is_required">&nbsp;*</span>
            </label>
            <button class="btn btn-link btn-sm pt-0 float-right"
                    (click)="questionInEditMode[question.id] = true">
              Edit Question
            </button>
            <input type="text" class="form-control">
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedMarkdown(question.description)"></small>
          </div>

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.multipleLineText">
            <label>
              <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
              <span *ngIf="question.is_required">&nbsp;*</span>
            </label>
            <button class="btn btn-link btn-sm pt-0 float-right"
                    (click)="questionInEditMode[question.id] = true">
              Edit Question
            </button>
            <textarea class="form-control"></textarea>
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedMarkdown(question.description)"></small>
          </div>

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.multipleChoice">
            <div class="d-inline-block w-100">
              <label class="mb-1">
                <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
                <span *ngIf="question.is_required">&nbsp;*</span>
              </label>
              <button class="btn btn-link btn-sm pt-0 float-right"
                      (click)="questionInEditMode[question.id] = true">
                Edit Question
              </button>
            </div>
            <div class="form-check" *ngFor="let option of question.options.split(',')">
              <input class="form-check-input" type="radio" name="{{ question.id }}">
              <label class="form-check-label">{{ option }}</label>
            </div>
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedMarkdown(question.description)"></small>
          </div>

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.singleCheckbox">
            <div class="form-check">
              <input type="checkbox" class="form-check-input">
              <label class="form-check-label">
                <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
                <span *ngIf="question.is_required">&nbsp;*</span>
              </label>
              <button class="btn btn-link btn-sm pt-0 float-right"
                      (click)="questionInEditMode[question.id] = true">
                Edit Question
              </button>
            </div>
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedMarkdown(question.description)"></small>
          </div>

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.multipleCheckboxes">
            <div class="d-inline-block w-100">
              <label class="mb-1">
                <span [innerHTML]="getRenderedInlineMarkdown(question.name)"></span>
                <span *ngIf="question.is_required">&nbsp;*</span>
              </label>
              <button class="btn btn-link btn-sm pt-0 float-right"
                      (click)="questionInEditMode[question.id] = true">
                Edit Question
              </button>
            </div>
            <div class="form-check" *ngFor="let option of question.options.split(',')">
              <input class="form-check-input" type="checkbox" name="{{ question.id }}">
              <label class="form-check-label">{{ option }}</label>
            </div>
            <small class="form-text text-muted"
                   *ngIf="question.is_required">
              <ng-container *ngIf="question.all_options_required">
                All of the above checkboxes must be selected before proceeding.
              </ng-container>
              <ng-container *ngIf="!question.all_options_required">
                At least one of the above checkboxes must be selected before proceeding.
              </ng-container>
            </small>
            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedMarkdown(question.description)"></small>
          </div>

          <div class="form-group" *ngIf="question.question_type === EventQuestionType.customCustomerField">

            <ng-container *ngIf="question.custom_customer_field_type === CustomCustomerFieldType.checkboxes">
              <div class="d-inline-block w-100">
                <label class="mb-1">
                  {{ question.custom_customer_field_name }}
                  <span *ngIf="question.is_required">*</span>
                </label>
                <button class="btn btn-link btn-sm pt-0 float-right"
                        (click)="questionInEditMode[question.id] = true">
                  Edit Question
                </button>
              </div>
              <div class="form-check" *ngFor="let option of question.custom_customer_field_options; index as idx">
                <input class="form-check-input" type="checkbox"
                       name="customFieldCHK{{ question.custom_customer_field_id }}-{{ idx }}"
                       id="customFieldCHK{{ question.custom_customer_field_id }}-{{ idx }}">
                <label class="form-check-label" for="customFieldCHK{{ question.custom_customer_field_id }}-{{ idx }}">
                  {{ option }}
                </label>
              </div>
            </ng-container>

            <ng-container *ngIf="question.custom_customer_field_type === CustomCustomerFieldType.dropdown">
              <label class="mb-1"
                     for="customFieldDRP{{ question.custom_customer_field_id }}">
                {{ question.custom_customer_field_name }}
                <span *ngIf="question.is_required">*</span>
              </label>
              <button class="btn btn-link btn-sm pt-0 float-right"
                      (click)="questionInEditMode[question.id] = true">
                Edit Question
              </button>
              <select class="custom-select"
                      id="customFieldDRP{{ question.custom_customer_field_id }}"
                      name="customFieldDRP{{ question.custom_customer_field_id }}">
                <option *ngFor="let option of question.custom_customer_field_options">
                  {{ option }}
                </option>
              </select>
            </ng-container>

            <ng-container *ngIf="question.custom_customer_field_type === CustomCustomerFieldType.radio">
              <div class="d-inline-block w-100">
                <label class="mb-1">
                  {{ question.custom_customer_field_name }}
                  <span *ngIf="question.is_required">*</span>
                </label>
                <button class="btn btn-link btn-sm pt-0 float-right"
                        (click)="questionInEditMode[question.id] = true">
                  Edit Question
                </button>
              </div>
              <div class="form-check" *ngFor="let option of question.custom_customer_field_options; index as idx">
                <input class="form-check-input" type="radio"
                       id="customFieldRDO{{ question.custom_customer_field_id }}-{{ idx }}"
                       name="customFieldRDO{{ question.custom_customer_field_id }}">
                <label class="form-check-label" for="customFieldRDO{{ question.custom_customer_field_id }}-{{ idx }}">
                  {{ option }}
                </label>
              </div>
            </ng-container>

            <ng-container *ngIf="question.custom_customer_field_type === CustomCustomerFieldType.singleLineText">
              <label class="mb-1"
                     for="customFieldSLT{{ question.custom_customer_field_id }}">
                {{ question.custom_customer_field_name }}
                <span *ngIf="question.is_required">*</span>
              </label>
              <button class="btn btn-link btn-sm pt-0 float-right"
                      (click)="questionInEditMode[question.id] = true">
                Edit Question
              </button>
              <input id="customFieldSLT{{ question.custom_customer_field_id }}"
                     name="customFieldSLT{{ question.custom_customer_field_id }}"
                     type="text" class="form-control" maxlength="127">
            </ng-container>

            <ng-container *ngIf="question.custom_customer_field_type === CustomCustomerFieldType.multipleLineText">
              <label class="mb-1"
                     for="customFieldMLT{{ question.custom_customer_field_id }}">
                {{ question.custom_customer_field_name }}
                <span *ngIf="question.is_required">*</span>
              </label>
              <button class="btn btn-link btn-sm pt-0 float-right"
                      (click)="questionInEditMode[question.id] = true">
                Edit Question
              </button>
              <textarea id="customFieldMLT{{ question.custom_customer_field_id }}"
                        name="customFieldMLT{{ question.custom_customer_field_id }}"
                        class="form-control"></textarea>
            </ng-container>

            <small class="form-text text-muted"
                   *ngIf="question.description"
                   [innerHTML]="getRenderedMarkdown(question.description)"></small>

          </div>

        </div>

      </div>

      <p class="text-muted" *ngIf="!loadingEventQuestionsList && bookingCustomerQuestions.length === 0">
        <b>No booking customer questions are configured.</b>
      </p>

      <div class="row">
        <div class="col">
          <button class="btn btn-outline-primary mb-4"
                  (click)="addNewQuestion(EventQuestionScope.bookingCustomer)">
            Add Booking Customer Question
          </button>
        </div>
      </div>

      <div class="alert alert-info" role="alert" *ngIf="loadingEventQuestionsList">
        Loading questions...
      </div>

      <div class="float-right">
        <button type="submit" class="btn btn-primary mr-2"
                [disabled]="isLoading()" [class.disabled]="isLoading()"
                (click)="submitType=SUBMIT_TYPE_GO_BACK;saveAll()">
          Save and Go Back
        </button>
        <button type="submit" class="btn btn-primary"
                [disabled]="isLoading()" [class.disabled]="isLoading()"
                (click)="submitType=SUBMIT_TYPE_CONTINUE;saveAll()">
          Save and Continue
        </button>
      </div>
      <button [routerLink]="['/events/setup/event-types']"
              [queryParams]="{status: eventType?.status}"
              class="btn btn-secondary"
              [disabled]="isLoading()" [class.disabled]="isLoading()">
        Back
      </button>

    </div>

  </div>

</div>
